const FormLabel = {
  baseStyle: {
    _invalid: { 
      color: "feedback.negative.100"
    }
  },
};

export default FormLabel;
